module.exports = __webpack_public_path__ + "img/ring_r_e_null_0@3x.00ea0d54.png";